import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { SeoConfig } from '@klaro7/shared-types';

import { getPublicSeoConfig, getSeoConfig, updateSeoConfig, uploadSeoImage } from '../services/seo.service';

/** Public SEO config: one fetch per session, meta tags rarely change. */
export function usePublicSeoConfig() {
  return useQuery({
    queryKey: ['seo', 'public'],
    queryFn: getPublicSeoConfig,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

export function useSeoConfig() {
  return useQuery({
    queryKey: ['seo', 'admin'],
    queryFn: getSeoConfig,
  });
}

export function useUpdateSeoConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: Partial<SeoConfig>) => updateSeoConfig(payload),
    onSuccess: (config) => {
      queryClient.setQueryData(['seo', 'admin'], config);
      queryClient.invalidateQueries({ queryKey: ['seo', 'public'] });
    },
  });
}

export function useUploadSeoImage() {
  return useMutation({ mutationFn: uploadSeoImage });
}
